import "../../styles/blocks/project-page/project-gallery.scss";

import React, {useLayoutEffect, useRef} from "react";
import PropTypes from "prop-types";
import {GatsbyImage as Image} from "gatsby-plugin-image";
import {convertToBgImage} from "gbimage-bridge";

import ScrollContainer from 'react-indiana-drag-scroll';

const ProjectGallery = ({images, backgroundColorOfSlides, projectTitle}) => {
    const galleryWrapperRef = useRef();

    useLayoutEffect(() => {
        if (galleryWrapperRef.current.children[0].scrollLeft + galleryWrapperRef.current.children[0].offsetWidth >= galleryWrapperRef.current.children[0].scrollWidth) {
            galleryWrapperRef.current.classList.remove("blur-right");
        }
    }, [])

    const onScrollHandler = () => {
        if (!galleryWrapperRef.current.children[0].scrollLeft) {
            galleryWrapperRef.current.classList.remove("active-left");
        } else {
            galleryWrapperRef.current.classList.add("active-left");

        }

        if (galleryWrapperRef.current.children[0].scrollLeft + galleryWrapperRef.current.children[0].offsetWidth >= galleryWrapperRef.current.children[0].scrollWidth) {
            galleryWrapperRef.current.classList.remove("active-right");
        } else {
            galleryWrapperRef.current.classList.add("active-right");
        }
    };

    return (
        <section
            className="project-gallery"
            style={{
                "--slides-background-color": backgroundColorOfSlides
            }}
        >
            <div className="project-gallery__wrapper container blur-right blur-left" ref={galleryWrapperRef}>
                <ScrollContainer
                    className="project-gallery__scroll-wrapper"
                    onScroll={()=> onScrollHandler()}
                >
                    {images.filter(image => image).map(({image, sidePaddingDesktop}, index) => {
                        const altText = image.altText || projectTitle;
                        const gatsbyImageData = image.localFile?.childImageSharp?.gatsbyImageData ?? {};

                        const backgroundImage = convertToBgImage(gatsbyImageData);

                        if (!backgroundImage || !backgroundImage?.fluid) {
                            return null;
                        }

                        return (
                            <div
                                key={index}
                                className="project-gallery__image-item"
                                style={{
                                    "--slide-side-padding-desktop": `${sidePaddingDesktop}px`,
                                    "--aspect-ratio": ` ${backgroundImage.fluid.aspectRatio}`
                                }}
                            >
                                <div className="project-gallery__image-wrapper">
                                    <Image
                                        className="project-gallery__image"
                                        image={gatsbyImageData}
                                        alt={altText || ""}
                                        title={altText || ""}
                                        tabIndex="0"
                                    />
                                </div>
                            </div>
                        );
                    })}
                </ScrollContainer>
            </div>
        </section>
    );
};

ProjectGallery.propTypes = {
    projectTitle: PropTypes.string.isRequired,
    images: PropTypes.array.isRequired,
    backgroundColorOfSlides: PropTypes.string
};

export default ProjectGallery;
